/**
 * Public outward links. Replace the search URLs with the exact page/store
 * handles when the owner supplies them; the current values keep every link
 * useful until those handles are confirmed.
 */
export const SITE_LINKS = {
  linkedin: 'https://www.linkedin.com/in/brandt-green-84070a287',
  facebook: 'https://www.facebook.com/search/top?q=GreenTree%20Arboriculture%20Columbus%20GA',
  instagram: 'https://www.instagram.com/explore/tags/greentreearboriculture/',
  youtube: 'https://www.youtube.com/@mrgreenGTArbor',
  tiktok: 'https://www.tiktok.com/@brandt.green4',
  ebay: 'https://www.ebay.com/sch/i.html?_nkw=GreenTree+Arboriculture',
} as const;
